import { AccountTree, Info, Layers } from "@mui/icons-material"
import { Stack } from "@mui/material"
import { Route, Routes, useParams } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { useAuth } from "../../auth"
import Layout from "../../components/Layout"
import { PageTitle } from "../../components/PageTitle"
import { useAssemblaggio } from "../../hooks/assemblaggi"
import Supporti from "../Supporti"
import AssemblaggioDettaglio from "./AssemblaggioDettaglio"

export default function Assemblaggio() {
  const { id } = useParams()
  const { t, i18n } = useTranslation()
  const { data: assemblaggio } = useAssemblaggio(parseInt(id as string))
  const { user } = useAuth()
  const lang = i18n.language

  return (
    <Layout>
      <Stack sx={{ height: "100%", overflow: "hidden" }}>
        <PageTitle
          padding
          border
          title={assemblaggio?.nome || ""}
          breadcrumbs={[
            {
              label: t("general.assemblaggi"),
              iconType: AccountTree,
              to: `/${lang}/assemblaggi`,
            },
            {
              label: assemblaggio?.nome || "",
            },
          ]}
          tabs={
            user?.ruolo !== "consultazione"
              ? [
                  {
                    label: t("general.dettaglio"),
                    iconType: Info,
                    to: `/${lang}/assemblaggi/${id}`,
                  },
                  {
                    label: t("general.supporti"),
                    iconType: Layers,
                    to: `/${lang}/assemblaggi/${id}/supporti`,
                  },
                ]
              : []
          }
        />
        <Routes>
          <Route index element={<AssemblaggioDettaglio />} />
          <Route path="supporti" element={<Supporti assemblaggioId={Number(id)} />} />
        </Routes>
      </Stack>
    </Layout>
  )
}
